import * as React from "react";
import {
  List,
  Datagrid,
  TextField,
  NumberField,
  BooleanField,
  DateField,
  TextInput,
  FunctionField,
} from "react-admin";
import { useClub } from "../club/ClubContext";

function ruleLabel(rule?: string) {
  if (!rule) return "—";
  const periodic =
    rule.endsWith("_per_week") || rule.endsWith("_per_month") || rule.endsWith("_per_year");

  const base = rule
    .replace("_per_week", "")
    .replace("_per_month", "")
    .replace("_per_year", "");

  const periodSuffix = rule.endsWith("_per_week")
    ? " (Woche)"
    : rule.endsWith("_per_month")
      ? " (Monat)"
      : rule.endsWith("_per_year")
        ? " (Jahr)"
        : "";

  switch (base) {
    case "trainings_completed":
      return periodic ? `Trainings${periodSuffix}` : "Trainings (einmalig / window)";
    case "numeric_games_completed":
      return periodic ? `Numeric Games${periodSuffix}` : "Numeric Games (einmalig / window)";
    case "numeric_score_hits":
      return `Numeric Score >= X${periodSuffix || ""}`;
    case "numeric_value_hits":
      return `Numeric Value Hits (z. B. 180 Count)${periodSuffix || ""}`;
    default:
      return rule;
  }
}

function paramsSummary(rec: any) {
  const rt = rec?.rule_type as string | undefined;
  const p = rec?.params ?? {};
  if (!rt) return "—";

  if (rt.startsWith("numeric_score_hits")) {
    return p?.match_score != null ? `match_score: ${p.match_score}` : "match_score: —";
  }
  if (rt.startsWith("numeric_value_hits")) {
    return p?.score != null ? `score: ${p.score}` : "score: —";
  }
  return "—";
}

export function ChallengeList(props: any) {
  const { clubId } = useClub();

  const filters = [<TextInput key="q" source="q" label="Suche" alwaysOn />];

  return (
    <List
      {...props}
      filters={filters}
      filter={clubId ? { club_id: clubId } : {}}
      perPage={50}
      sort={{ field: "id", order: "DESC" }}
    >
      <Datagrid rowClick="edit">
        <TextField source="name" />
        <FunctionField
          label="Regel"
          render={(rec: any) => ruleLabel(rec?.rule_type)}
        />
        <NumberField source="target" />
        <NumberField source="window_days" />
        <FunctionField label="Params" render={(rec: any) => paramsSummary(rec)} />
        <NumberField source="reward_points" />
        <DateField source="starts_on" />
        <DateField source="ends_on" />
        <BooleanField source="is_active" />
      </Datagrid>
    </List>
  );
}
